/**
 * This component is the My Statements page.  It is a light wrapper for the Statement component.
 */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';

import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';
import { Paper, Typography } from '@mui/material';

import VendorStatement from '../account/VendorStatement';
import ResellerStatement from '../account/ResellerStatement';
import ResellerWalletStatement from '../account/ResellerWalletStatement';
import CustomerStatement2 from '../customer/CustomerStatement2'; 
import CustomerProjectStatement from '../customer/CustomerProjectStatement'; 
import PageTitle from '../ui/PageTitle';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';

const abEnvironment = new AbEnvironment();

const MyStatementsQuery = graphql`
query MyStatementsQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountId
    accountType
    walletTsByAccountId {
      totalCount
      nodes{
          walletId
          
          accountTByAccountId {
            accountId
            accountName
          }
      }
    }
		projectTsByResellerAccountId(orderBy: PROJECT_NAME_ASC) {
      totalCount
      nodes {
        projectId
        projectName
        walletTByResellerWalletId {
          walletId
        }
        accountTByCustomerAccountId {
          accountName
        }
      }
    }
		projectTsByCustomerAccountId(orderBy: PROJECT_NAME_ASC) {
      totalCount
      nodes {
        projectId
        projectName
        walletTByCustomerWalletId {
          walletId
        }
      }
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      //marginTop: 10,
    },
    paper: {
      [theme.breakpoints.up('xs')]: {
        padding: theme.spacing(1),
      },
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(2),
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
      },
      textAlign: 'left',
      color: theme.palette.text.secondary,
       marginTop: 16,
    },
    flex: {
      flex: 1,
    },
  });

class MyStatements extends Component {
  render() {
    const { isAuthenticatedCustomer, isAuthenticatedReseller, isAuthenticatedVendor, isAuthenticatedAppBind, isUnauthenticatedCustomer, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (needAssent()) {
      return (
        <Redirect to='/home' />
      );
    }

    let acctId = abEnvironment.getUserAttribute("a_id");

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={MyStatementsQuery}
        variables={{ accountId: acctId }}
        render={({ error, props }) => {
          if (error) {
            logError(error.message);
            return (
              <ServerError />
            );
          } else if (props) {
            if (props.accountTByAccountId === null) {
              return (
                <React.Fragment>
                  <PageTitle title={"Account not found"} />
                </React.Fragment>
              );
            }




              if (isAuthenticatedAppBind())
              {
                return (
                  <div>
                    <PageTitle title="My statements" subtitle="Report of statements for your app subscriptions."/>
                    <p>
                      TBD goes here
                    </p>
                  </div>
                );
              }
              else if (isAuthenticatedReseller())
              {
                let pAcctId = abEnvironment.getUserAttribute("a_id");
          
                return (
                  <div className={classes.root}>
                    <PageTitle title="My statements" subtitle="What are my subscription charges and payments?"/>
          
                    <Paper className={classes.paper}>
                      {props.accountTByAccountId.walletTsByAccountId.totalCount >= 0 &&
                        <ResellerStatement pAccountId={pAcctId} auth={this.props.auth} history={this.props.history}/>
                      }
                      {props.accountTByAccountId.walletTsByAccountId.totalCount > 0  &&
                        <Paper  className={classes.paper}>
                          <Typography variant="h6" style={{marginBottom: '16px'}}>Wallet statements</Typography>
                          <ResellerWalletStatement pAccountId={pAcctId} wallets={props.accountTByAccountId.walletTsByAccountId.nodes} auth={this.props.auth} history={this.props.history}/>
                        </Paper>
                      }
                    </Paper>
                  </div>
                );
              }
              else if (isAuthenticatedVendor())
              {
                let vAcctId = abEnvironment.getUserAttribute("a_id");
          
                return (
                  <div className={classes.root}>
                    <PageTitle title="My statements" subtitle="What are my subscription charges and rebate payouts?"/>
          
                    <Paper className={classes.paper}>
                      <VendorStatement vAccountId={vAcctId} auth={this.props.auth} history={this.props.history}/>
                    </Paper>
                  </div>
                );
              }
              else if (isAuthenticatedCustomer() || isUnauthenticatedCustomer())
              {
                let cAcctId = abEnvironment.getUserAttribute("a_id");
                const params = new URLSearchParams(this.props.location.search);
                let current = params.get('current');
                let initialStatement = 0;
                if (current) {
                  initialStatement = 1;
                }
            
                return (
                  <div className={classes.root}>
                    <PageTitle title="My statements" subtitle="What are my subscription charges and payments?"/>
          
                    {props.accountTByAccountId.projectTsByCustomerAccountId.totalCount >= 0 &&
                    <Paper className={classes.paper}>
                        <CustomerStatement2 cAccountId={cAcctId} auth={this.props.auth} history={this.props.history} initialStatement={initialStatement}/>
                    </Paper>
                    }
                    {props.accountTByAccountId.projectTsByCustomerAccountId.totalCount > 0 &&
                    <Paper className={classes.paper}>
                      <Typography variant="h6" style={{marginBottom: '16px'}}>Project statements</Typography>
                      <CustomerProjectStatement cAccountId={cAcctId} projects={props.accountTByAccountId.projectTsByCustomerAccountId.nodes} auth={this.props.auth} history={this.props.history} initialStatement={initialStatement}/>
                    </Paper>
                    }

                  </div>
                );
              }
              else
              {
                return (
                  <Redirect to='/home' />
                );
              }

          }
          return <LoadingSpinner />
        }}
      />
    );



  }
}

export default withStyles(styleSheet)(MyStatements);
